import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { AccountFacade } from '@corelabs/angular/account';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';
import { filter, take, tap } from 'rxjs';

@Injectable()
export class AccountSessionExpiredService {
    private readonly accountFacade = inject(AccountFacade);
    private readonly router = inject(Router);
    private readonly messageService = inject(MessageService);
    private readonly translateService = inject(TranslateService);

    constructor() {
        // A one-shot pulse reset to null in the same dispatch - a scheduled signal effect would always miss it.
        this.accountFacade.sessionExpired$
            .pipe(
                filter((sessionExpired) => sessionExpired === true),
                take(1),
                tap(() => this.handleSessionExpired()),
                takeUntilDestroyed(),
            )
            .subscribe();
    }

    private handleSessionExpired() {
        this.messageService.add(this.translateService.instant('account.error.session-expired'), 'danger');
        this.router.navigate(['/', 'auth', 'logout'], { skipLocationChange: true });
    }
}
